import {createContext} from "react";
import {IAccountContext} from "../models/Account/IAccountContext.ts";
import {IGetMeResponse} from "../../response/account/getMeResponse.ts";

export const AccountContext = createContext<IAccountContext>({
    // logoutEverywhere: async () => { },
    changePassword: async (actualPassword: string, password: string, confirmPassword: string, logoutFromAllDevices: boolean) => {
        actualPassword;
        confirmPassword;
        password;
        logoutFromAllDevices;
    },
    getMe: function (): Promise<void> {
        throw new Error("Function not implemented.");
    }
});